var map = {
	"./Crypto/auth_bg.jpg": 31722,
	"./Emerald/auth_bg.jpg": 80531,
	"./Emerald/background-chat.jpg": 82692,
	"./NavyBlue/auth_bg.jpg": 58581,
	"./NavyBlue/background-chat.jpg": 92346,
	"./av/1.svg": 31103,
	"./av/2.svg": 52076,
	"./av/3.svg": 99437,
	"./av/4.svg": 70914,
	"./av/5.svg": 74643,
	"./av/6.svg": 13632,
	"./av/7.svg": 28017,
	"./av/down.svg": 70554,
	"./av/downc.svg": 14293,
	"./av/up.svg": 521,
	"./av/upc.svg": 63896,
	"./bg-empty-list.png": 59884,
	"./bi_question-circle.svg": 11021,
	"./chevron-down.svg": 95420,
	"./chevron-up.svg": 6167,
	"./clarity_settings-line.svg": 77365,
	"./currs/RUR.svg": 1723,
	"./empty-assets.png": 2123,
	"./external-link.svg": 8220,
	"./icons/africa-solid.svg": 41343,
	"./icons/again-w.svg": 40853,
	"./icons/again.svg": 74497,
	"./icons/archive.svg": 39363,
	"./icons/arrow-down-right-active-navy.svg": 68566,
	"./icons/arrow-down-right-active.svg": 69901,
	"./icons/arrow-down-right-green.svg": 87180,
	"./icons/arrow-down-right.svg": 12406,
	"./icons/arrow-to-new-window-white.svg": 88070,
	"./icons/arrow-to-new-window.svg": 51466,
	"./icons/arrow-up-right-active-navy.svg": 47581,
	"./icons/arrow-up-right-active.svg": 99116,
	"./icons/arrow-up-right-green.svg": 75735,
	"./icons/arrow-up-right.svg": 35153,
	"./icons/back.svg": 79082,
	"./icons/bank.svg": 73209,
	"./icons/bookmark.svg": 80359,
	"./icons/btc.svg": 10396,
	"./icons/burg-active-navy.svg": 46337,
	"./icons/burg-active.svg": 64256,
	"./icons/burg.svg": 73613,
	"./icons/cancel-w.svg": 97809,
	"./icons/cancel.svg": 14426,
	"./icons/card-payment.svg": 26032,
	"./icons/card.svg": 94817,
	"./icons/catalog.svg": 32204,
	"./icons/check-maker-verification.svg": 51398,
	"./icons/check-mark.svg": 13025,
	"./icons/check.svg": 82497,
	"./icons/chevron-down.svg": 79573,
	"./icons/chevron-up.svg": 93357,
	"./icons/clip-icon.svg": 18241,
	"./icons/clock.svg": 92075,
	"./icons/close.svg": 35837,
	"./icons/coins.svg": 27339,
	"./icons/copy.svg": 28552,
	"./icons/crypt.svg": 43817,
	"./icons/crypto-empty-logo.svg": 97512,
	"./icons/crypto/bank.svg": 26481,
	"./icons/crypto/bookmark.svg": 37007,
	"./icons/crypto/card.svg": 40601,
	"./icons/crypto/crypt.svg": 72161,
	"./icons/crypto/cryptokey.svg": 33473,
	"./icons/crypto/docs.svg": 55154,
	"./icons/crypto/headphones.svg": 72302,
	"./icons/crypto/invest.svg": 77148,
	"./icons/crypto/lock.svg": 40690,
	"./icons/crypto/logout.svg": 57773,
	"./icons/crypto/mailbox.svg": 95581,
	"./icons/crypto/masspayment.svg": 86179,
	"./icons/crypto/merchant_shop.svg": 79498,
	"./icons/crypto/notification.svg": 49486,
	"./icons/crypto/p2p.svg": 40907,
	"./icons/crypto/partnerServices.svg": 61639,
	"./icons/crypto/pay.svg": 89439,
	"./icons/crypto/profile.svg": 19430,
	"./icons/crypto/transfer.svg": 46710,
	"./icons/default-curr.svg": 21447,
	"./icons/default-shop.svg": 84651,
	"./icons/docs.svg": 19498,
	"./icons/download.svg": 91303,
	"./icons/download_w.svg": 16145,
	"./icons/echeck-pay.svg": 81977,
	"./icons/edit-status-incass.svg": 92640,
	"./icons/edit.svg": 975,
	"./icons/edit_bl.svg": 76200,
	"./icons/email.svg": 11089,
	"./icons/email_g.svg": 55443,
	"./icons/empty-uploader.svg": 45577,
	"./icons/equal.svg": 29529,
	"./icons/error-close.svg": 19788,
	"./icons/error-picture.svg": 51606,
	"./icons/eth.svg": 47296,
	"./icons/external-link-orange.svg": 37766,
	"./icons/external-link-white.svg": 23367,
	"./icons/external-link.svg": 839,
	"./icons/eye-dollar-icon.svg": 58277,
	"./icons/eye-off.svg": 59210,
	"./icons/eye.svg": 34426,
	"./icons/file-text.svg": 67671,
	"./icons/file_download.svg": 23736,
	"./icons/h-phones.svg": 52113,
	"./icons/headphones.svg": 2582,
	"./icons/icon-full-table.svg": 32737,
	"./icons/info-asset.svg": 47028,
	"./icons/invest.svg": 39300,
	"./icons/investment_1.svg": 94572,
	"./icons/investment_1_g.svg": 61510,
	"./icons/li_arrow-down-from-line.svg": 31757,
	"./icons/li_arrow-left.svg": 79638,
	"./icons/li_arrow-up-from-line.svg": 49562,
	"./icons/li_book.svg": 89302,
	"./icons/li_bot-message-square.svg": 59466,
	"./icons/li_calendar-days.svg": 86937,
	"./icons/li_chevron-left.svg": 9112,
	"./icons/li_chevron-right.svg": 47015,
	"./icons/li_chevrons-up-down.svg": 11298,
	"./icons/li_circle-check.svg": 14666,
	"./icons/li_circle-x.svg": 40974,
	"./icons/li_copy.svg": 61930,
	"./icons/li_ellipsis.svg": 93548,
	"./icons/li_eye-off.svg": 73236,
	"./icons/li_file-text.svg": 15777,
	"./icons/li_globe.svg": 28748,
	"./icons/li_info.svg": 44137,
	"./icons/li_key-round.svg": 64205,
	"./icons/li_linkedin.svg": 24119,
	"./icons/li_lock-keyhole-open.svg": 90869,
	"./icons/li_mail.svg": 98216,
	"./icons/li_monitor.svg": 46077,
	"./icons/li_move-down.svg": 77675,
	"./icons/li_move-up.svg": 74628,
	"./icons/li_pencil.svg": 81394,
	"./icons/li_plus.svg": 89153,
	"./icons/li_settings.svg": 59662,
	"./icons/li_store.svg": 53304,
	"./icons/li_text.svg": 23208,
	"./icons/li_trash.svg": 29577,
	"./icons/li_wallet.svg": 28550,
	"./icons/li_wand.svg": 75467,
	"./icons/lock-support.svg": 45004,
	"./icons/lock.svg": 45482,
	"./icons/logout.svg": 34277,
	"./icons/mailbox.svg": 97125,
	"./icons/masspayment.svg": 57851,
	"./icons/menu-admin-icon 1.svg": 28035,
	"./icons/menu-admin-icon.svg": 38578,
	"./icons/merchant_shop.svg": 83682,
	"./icons/message-send.svg": 38979,
	"./icons/minus.svg": 48441,
	"./icons/monero.svg": 60481,
	"./icons/money-bag.svg": 78436,
	"./icons/money-emission.svg": 50363,
	"./icons/not-verification.svg": 72182,
	"./icons/notification.svg": 30566,
	"./icons/p2p.svg": 62147,
	"./icons/p2p_pay.svg": 70180,
	"./icons/password-icon.svg": 72478,
	"./icons/pay.svg": 26727,
	"./icons/pay_code.svg": 65705,
	"./icons/payment.svg": 39663,
	"./icons/payments.svg": 24366,
	"./icons/phone.svg": 16345,
	"./icons/phone_g.svg": 61643,
	"./icons/pin.svg": 92528,
	"./icons/pin_false.svg": 57232,
	"./icons/plus-blue.svg": 16888,
	"./icons/plus-orange.svg": 25930,
	"./icons/plus-white.svg": 36891,
	"./icons/plus.svg": 24491,
	"./icons/pro-deal-check.svg": 2912,
	"./icons/profile.svg": 22030,
	"./icons/remove-value.svg": 28615,
	"./icons/repeat.svg": 71466,
	"./icons/rollback.svg": 58139,
	"./icons/search-grey.svg": 32665,
	"./icons/search.svg": 64343,
	"./icons/search_w.svg": 6785,
	"./icons/star.svg": 40815,
	"./icons/swap.svg": 83182,
	"./icons/table-icon.svg": 25981,
	"./icons/template.svg": 79477,
	"./icons/tools-icon.svg": 57826,
	"./icons/transfer-green.svg": 18148,
	"./icons/transfer.svg": 97422,
	"./icons/trash-off.svg": 62467,
	"./icons/trash.svg": 59272,
	"./icons/usdt.svg": 61815,
	"./icons/user_4_1.svg": 85911,
	"./icons/user_4_1_g.svg": 60785,
	"./icons/warning.svg": 42865,
	"./icons/waves.svg": 35931,
	"./icons/whatsapp 1.svg": 48136,
	"./icons/wid_code.svg": 159,
	"./icons/x.svg": 99897,
	"./icons/x_gray.svg": 16097,
	"./icons/x_red.svg": 99369,
	"./ion_exit-outline.svg": 26870,
	"./logo.png": 33153,
	"./masspayment_file/en.png": 1233,
	"./masspayment_file/ru.png": 49183,
	"./masspayment_file_550.png": 91992,
	"./masspayment_form/en.png": 48257,
	"./masspayment_form/ru.png": 58255,
	"./masspayment_form_550.png": 94376,
	"./mobile_logo_default.svg": 12716,
	"./operator_groups/base/1.svg": 65231,
	"./operator_groups/base/10.svg": 86733,
	"./operator_groups/base/11.svg": 87788,
	"./operator_groups/base/12.svg": 66815,
	"./operator_groups/base/13.svg": 38382,
	"./operator_groups/base/14.svg": 36881,
	"./operator_groups/base/15.svg": 928,
	"./operator_groups/base/16.svg": 21683,
	"./operator_groups/base/17.svg": 16514,
	"./operator_groups/base/18.svg": 61157,
	"./operator_groups/base/19.svg": 9988,
	"./operator_groups/base/2.svg": 86204,
	"./operator_groups/base/20.svg": 36836,
	"./operator_groups/base/21.svg": 91557,
	"./operator_groups/base/3.svg": 75677,
	"./operator_groups/base/4.svg": 41746,
	"./operator_groups/base/5.svg": 56387,
	"./operator_groups/base/6.svg": 99344,
	"./operator_groups/base/6_.svg": 17943,
	"./operator_groups/base/7.svg": 34881,
	"./operator_groups/base/8.svg": 23990,
	"./operator_groups/base/9.svg": 87815,
	"./operator_groups/base/unknown.svg": 48076,
	"./operator_groups/small/1.svg": 89553,
	"./operator_groups/small/10.svg": 17843,
	"./operator_groups/small/11.svg": 12674,
	"./operator_groups/small/12.svg": 33041,
	"./operator_groups/small/13.svg": 97088,
	"./operator_groups/small/14.svg": 62975,
	"./operator_groups/small/15.svg": 34542,
	"./operator_groups/small/16.svg": 82893,
	"./operator_groups/small/17.svg": 83948,
	"./operator_groups/small/18.svg": 10827,
	"./operator_groups/small/19.svg": 79866,
	"./operator_groups/small/2.svg": 9154,
	"./operator_groups/small/20.svg": 4670,
	"./operator_groups/small/21.svg": 67247,
	"./operator_groups/small/3.svg": 23379,
	"./operator_groups/small/4.svg": 82988,
	"./operator_groups/small/5.svg": 18445,
	"./operator_groups/small/6.svg": 7726,
	"./operator_groups/small/7.svg": 45663,
	"./operator_groups/small/9.svg": 18281,
	"./operator_groups/small/unknown.svg": 46598,
	"./reg_eshop.png": 50104,
	"./search.svg": 98246,
	"./tablet_logo_default.svg": 95606,
	"./test-money.png": 47067,
	"./user.svg": 46975
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 50290;